import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  },
  badge: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#E1251B',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFFFF',
    flexShrink: 0,
    boxShadow: '0 2px 4px rgba(225, 37, 27, 0.25)',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
  },
  companyName: {
    fontFamily: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, sans-serif',
    fontWeight: 700,
    fontSize: 13,
    color: '#111114',
    lineHeight: '16px',
    letterSpacing: '-0.2px',
    whiteSpace: 'nowrap',
  },
  subTitle: {
    fontFamily: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, sans-serif',
    fontWeight: 600,
    fontSize: 10,
    color: '#E1251B',
    lineHeight: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.badge}>
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
      </div>
      <div className={classes.textContainer}>
        <span className={classes.companyName}>SiCepat Ekspres</span>
        <span className={classes.subTitle}>DEVELOPER PORTAL</span>
      </div>
    </div>
  );
};

export default LogoFull;
